// extracted by mini-css-extract-plugin
export var container_img = "wholesale-module--container_img--8Ol-9";
export var container_info = "wholesale-module--container_info--uGlCE";
export var form_footer = "wholesale-module--form_footer--EGh6j";
export var header_bg = "wholesale-module--header_bg--9j1vE";
export var hidden = "wholesale-module--hidden--OKO0j";
export var intro_container = "wholesale-module--intro_container--2I8kF";
export var intro_containers = "wholesale-module--intro_containers--wRLCt";
export var required = "wholesale-module--required--5px23";
export var wholesale_form = "wholesale-module--wholesale_form--0ypJ8";
export var wholesale_form_intro = "wholesale-module--wholesale_form_intro--UZFUD";
export var wholesale_gallery = "wholesale-module--wholesale_gallery--4RmyE";
export var wholesale_imgs = "wholesale-module--wholesale_imgs--jRUdG";
export var wholesale_intro = "wholesale-module--wholesale_intro--SIPAk";